export const MarketingConsentServicesDK = [
  'Forsikring',
  'Internet',
  'Telefoni',
  'El',
  'Kreditcheck',
  'Virksomhedslån',
];
